// Simple encryption key (you can change this to something more secure)
const ENCRYPTION_KEY = 'emerald_system_2024';

// Custom UTF-8 safe base64 encoding function
const utf8ToBase64 = (str) => {
  try {
    // First convert the string to UTF-8 encoding
    const bytes = new TextEncoder().encode(str);
    // Then convert the bytes to a string
    let binary = '';
    for (let i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    // Finally use btoa on the binary string
    return btoa(binary);
  } catch (error) {
    console.error('UTF-8 to Base64 conversion error:', error);
    return '';
  }
};

// Custom base64 to UTF-8 decoding function
const base64ToUtf8 = (base64) => {
  try {
    // First decode base64 to binary
    const binary = atob(base64);
    // Create a Uint8Array to hold the bytes
    const bytes = new Uint8Array(binary.length);
    // Fill the array with the character codes
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    // Decode the UTF-8 bytes to a string
    return new TextDecoder().decode(bytes);
  } catch (error) {
    console.error('Base64 to UTF-8 conversion error:', error);
    return '';
  }
};

// Encrypt booking parameters
export const encryptBookingParams = (params) => {
  try {
    console.log('Encrypting parameters:', {
      checkIn: params.checkIn,
      checkOut: params.checkOut,
      guests: params.guests,
      property_code: params.property_code,
      roomCount: params.selectedRooms?.length || 0
    });
    
    // Validate params
    if (!params || typeof params !== 'object') {
      console.error('Invalid params for encryption:', params);
      return '';
    }
    
    // Ensure dates are properly formatted
    if (params.checkIn && params.checkOut) {
      console.log('Date validation - checkIn:', params.checkIn);
      console.log('Date validation - checkOut:', params.checkOut);
    }
    
    // Convert params object to string
    const paramsString = JSON.stringify(params);
    
    // Simple XOR encryption with the key
    let encrypted = '';
    for (let i = 0; i < paramsString.length; i++) {
      encrypted += String.fromCharCode(
        paramsString.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length)
      );
    }
    
    // Convert to base64 with UTF-8 support
    const base64 = utf8ToBase64(encrypted);
    
    // Make URL safe
    const urlSafe = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    console.log('Encryption successful, length:', urlSafe.length);
    return urlSafe;
  } catch (error) {
    console.error('Encryption error:', error);
    return '';
  }
};

// Decrypt booking parameters
export const decryptBookingParams = (encryptedString) => {
  try {
    console.log('Decrypting string, length:', encryptedString?.length);
    
    // Validate input
    if (!encryptedString || typeof encryptedString !== 'string') {
      console.error('Invalid encrypted string:', encryptedString);
      return null;
    }
    
    // Restore base64 characters
    const base64 = encryptedString.replace(/-/g, '+').replace(/_/g, '/');
    
    // Decode base64 with UTF-8 support
    const encrypted = base64ToUtf8(base64);
    console.log('Base64 decoded, length:', encrypted.length);
    
    // Decrypt XOR
    let decrypted = '';
    for (let i = 0; i < encrypted.length; i++) {
      decrypted += String.fromCharCode(
        encrypted.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length)
      );
    }
    
    // Parse back to object
    const result = JSON.parse(decrypted);
    
    // Log important date fields
    if (result) {
      console.log('Decryption successful with dates:', {
        checkIn: result.checkIn,
        checkOut: result.checkOut
      });
      
      // Validate dates in selectedRooms
      if (result.selectedRooms && Array.isArray(result.selectedRooms)) {
        result.selectedRooms.forEach((room, index) => {
          console.log(`Room ${index} dates:`, {
            checkIn: room.checkIn,
            checkOut: room.checkOut
          });
        });
      }
    }
    
    // Ensure result is an object
    if (!result || typeof result !== 'object') {
      console.error('Decryption result is not an object:', result);
      return null;
    }
    
    return result;
  } catch (error) {
    console.error('Decryption error:', error);
    // Return a default object structure with empty values instead of null
    return {
      checkIn: '',
      checkOut: '',
      adults: 2,
      children: 0,
      rooms: 1,
      roomId: '',
      roomType: '',
      rate: 0,
      rateCode: '',
      rateNote: '',
      breakfast_included: false,
      nights: 1
    };
  }
}; 